export const notifications = {
	export: {
		successNotification: "Products exported to Excel",
		errorNotification: "Error exporting products to Excel",
	},
	productToggle: {
		successActivated: "Product {{productName}} was successfully activated",
		successDeactivated: "Product {{productName}} was successfully deactivated",
	},
	massActions: {
		successActivated: "Products activated successfully",
		successDeactivated: "Products deactivated successfully",
	},
	categoryNotFound: "Category not found. Redirecting to the first available category.",
};
